import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Offices from "../views/Offices.vue";
import Office from "../views/Office.vue";
import Offer from "../views/Offer.vue";
import Terms from "../views/Terms.vue";
import Blog from "../views/Blog.vue";
import BlogPost from "../views/BlogPost.vue";
import Layer from "../views/Layer.vue";
import Start from "../views/Start.vue";
import Survey from "../views/Survey.vue";
import Summary from "../views/Summary.vue";
import Done from "../views/Done.vue";
import Fail from "../views/Fail.vue";
import Success from "../views/Success.vue";
import Error from "../views/Error.vue";
import store from "../store";
// import SurveyService from "@/survey.service.js";

Vue.use(VueRouter);

const scrollBehavior = (to, from, savedPosition) => {
  if (to.path == "/") {
    store.commit("setOpenedLayer", false);
    document.documentElement.classList.remove("noscroll");
  }
  if (savedPosition) {
    return savedPosition;
  } else {
    const position = { behavior: "smooth" };
    if (to.hash) {
      position.selector = to.hash;
      /* // specify offset of the element
      if (to.hash === "#anchor2") {
        position.offset = { y: 100 };
      } */
    } else {
      // window.scrollTo(0, 0);
    }
    /* if (to.matched.some((m) => m.meta.scrollToTop)) {
      position.x = 0;
      position.y = 0;
    } */
    return position;
  }
};

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    children: [
      {
        path: "/",
        name: "Start",
        component: Start
      },
      {
        path: "/kerdoiv/osszesito",
        name: "Summary",
        component: Summary
      },
      {
        path: "/kerdoiv/koszonjuk",
        name: "Done",
        component: Done
      },
      {
        path: "/kerdoiv/siker",
        name: "Siker",
        component: Success
      },
      {
        path: "/kerdoiv/hiba",
        name: "Hiba",
        component: Fail
      },
      {
        path: "/kerdoiv/:step",
        name: "Survey",
        component: Survey
      }
    ]
  },
  {
    path: "/irodak",
    name: "Offices",
    component: Offices
  },
  {
    path: "/irodak/:id",
    name: "Office",
    component: Office,
    meta: {
      title: "Office",
      behavior: "auto",
      scrollToTop: true
    }
  },
  {
    path: "/blog/:slug",
    name: "BlogPost",
    component: BlogPost
  },
  {
    path: "/blog/tag/:tag",
    name: "BlogTag",
    component: Blog
  },
  {
    path: "/blog",
    name: "Blog",
    component: Blog
  },
  {
    path: "/aszf",
    name: "ASZF",
    component: Terms,
    meta: {
      title: "ASZF",
      behavior: "auto",
      scrollToTop: true
    }
  },
  {
    path: "/modal",
    name: "Layer",
    component: Layer,
    children: [
      {
        path: "siker",
        name: "Siker",
        component: Success
      },
      {
        path: "hiba",
        name: "Hiba",
        component: Fail
      }
    ]
  },
  {
    path: "/ajanlat/:id",
    name: "Offer",
    component: Offer,
    meta: {
      title: "Offer",
      behavior: "auto",
      scrollToTop: true
    }
  },
  {
    path: "*",
    name: "Error",
    component: Error
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior /*: function(to) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
    }
  }, */
});

export default router;
